import React, { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';

interface PrivateRouteProps {
  children: React.ReactNode;
}
const PrivateRoute: FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to='/home' replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
